import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import * as authActions from 'app/auth/store/actions'
import FullScreenLoader from '../Loader/FullScreenLoader'

const LinkSignout = ({ text = 'Go back to Sign up methods' }) => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      {isOpen && <FullScreenLoader />}
      <div className="pt-10 text-center">
        <Link
          className="p-0 text-red-400 text-14 font-400 normal-case hover:bg-transparent cursor-pointer text-nowrap"
          onClick={() => {
            setIsOpen(true)
            dispatch(authActions.logoutUser())
          }}
        >
          {text}
        </Link>
      </div>
    </>
  )
}

LinkSignout.propTypes = {
  text: PropTypes.string,
}

export default LinkSignout
